module.exports = __webpack_public_path__ + "img/IMG_28532.4cb8cbd4.97f5b948.jpg";